import { render, staticRenderFns } from "./Assistente.vue?vue&type=template&id=793daf9e&scoped=true"
import script from "./Assistente.vue?vue&type=script&lang=js"
export * from "./Assistente.vue?vue&type=script&lang=js"
import style0 from "./Assistente.vue?vue&type=style&index=0&id=793daf9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793daf9e",
  null
  
)

export default component.exports